import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { useState } from "react";
import { Spinner } from "./Spinner";
import { MapMarkerGreyFilled } from "./MapMarkerGreyFilled";
import { Trans } from "@lingui/react";
import { useElementsContext } from "../elementsProvider";
// TODO extract to enviroment variable
const apiKey = "AIzaSyA72evBZVKJbP6rgoEW-r946TTI6JIN8Nk";
export function RTCMap({ size, query }) {
    const { isMobile } = useElementsContext();
    const [isLoading, setLoading] = useState(true);
    const isEmptyState = query.length === 0;
    const url = new URL("https://www.google.com/maps/embed/v1/place");
    url.searchParams.append("key", apiKey);
    url.searchParams.append("q", query);
    url.searchParams.append("zoom", "15");
    return (_jsx(MapContainer, Object.assign({ isDesktop: !isMobile, size: size }, { children: _jsx(MapContainerBackground, Object.assign({ isDesktop: !isMobile, size: size }, { children: !isEmptyState ? (_jsxs(_Fragment, { children: [_jsx(IconContainer, Object.assign({ isDesktop: !isMobile, isLoading: isLoading }, { children: isLoading && _jsx(Spinner, {}, void 0) }), void 0),
                    _jsx(MapIFrame, { allowFullScreen: true, frameBorder: "0", onLoad: () => setLoading(false), size: size, src: url.href, isDesktop: !isMobile }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx(WrapperSVGBackgroundMap, Object.assign({ isDesktop: !isMobile, size: size }, { children: _jsx(BackgroundMap, { isDesktop: !isMobile, src: "https://newrt.s3.amazonaws.com/emptystates/FeaturedImageText/BackgroudMap.svg", alt: "Empty state map" }, void 0) }), void 0),
                    _jsxs(BackgroundInfo, { children: [_jsx(MapMarkerGreyFilled, {}, void 0),
                            _jsx(BackgroudTitle, Object.assign({ isDesktop: !isMobile, "data-testid": "empty-state" }, { children: _jsx(Trans, { id: "¿Tenés un local? Podés mostrarlo en el mapa." }, void 0) }), void 0)] }, void 0)] }, void 0)) }), void 0) }), void 0));
}
const IconContainer = styled.div(({ isLoading, isDesktop }) => (Object.assign(Object.assign({ bottom: "50%", height: "2.4rem", position: "absolute", right: "50%", transform: "translate(50%, 50%)" }, (isDesktop
    ? {
        height: "4.8rem",
    }
    : {})), { "& svg": Object.assign({ height: "2.4rem", position: "relative", transform: isLoading ? "" : "translateY(-50%)" }, (isDesktop
        ? {
            height: "4.8rem",
        }
        : {})) })));
const heightSizes = {
    desktop: { big: 600, medium: 400, small: 200 },
    mobile: { big: 200, medium: 200, small: 200 },
};
const MapContainer = styled.section(({ size, isDesktop }) => (Object.assign({}, (isDesktop
    ? {
        height: `${heightSizes.desktop[size]}px`,
    }
    : {}))));
const MapContainerBackground = styled.div(({ size, isDesktop }) => (Object.assign({ height: `${heightSizes.mobile[size]}px`, position: "relative", width: "100%" }, (isDesktop
    ? {
        height: `${heightSizes.desktop[size]}px`,
    }
    : {}))));
const MapIFrame = styled.iframe(({ size, isDesktop }) => (Object.assign({ height: `${heightSizes.mobile[size]}px`, width: "100%" }, (isDesktop
    ? {
        height: `${heightSizes.desktop[size]}px`,
    }
    : {}))));
const WrapperSVGBackgroundMap = styled.span(({ size, isDesktop }) => ({
    "& img": Object.assign({ height: `${heightSizes.mobile[size]}px` }, (isDesktop
        ? {
            height: `${heightSizes.desktop[size]}px`,
        }
        : {})),
}));
const BackgroundMap = styled.img(({ isDesktop }) => (Object.assign({ width: "100%" }, (isDesktop
    ? {
        objectFit: "cover",
    }
    : {}))));
const BackgroundInfo = styled.div(() => ({
    bottom: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "absolute",
    right: "50%",
    transform: "translate(50%, 50%)",
    width: "fit-content",
    "& svg": {
        height: "4.8rem",
    },
}));
const BackgroudTitle = styled.span(({ isDesktop }) => (Object.assign({ fontFamily: "Open Sans, sans-serif", fontSize: "1.6rem" }, (isDesktop
    ? {
        fontSize: "2rem",
    }
    : {}))));
//# sourceMappingURL=Map.js.map